module.exports = __webpack_public_path__ + "static/media/XXIVh.f8423a8a.png";